module.exports = __webpack_public_path__ + "img/casa 2_thumb.3f6d354a.jpg";